import { combineReducers } from "redux";
import * as types from "../constants/ActionTypes";

const initialState = {
  data: {
    available_points: 0
  },
  ui: {
    fetching: false,
    error: null,
    prevTabPath: null
  }
};

const ui = (s = initialState.ui, a) => {
  switch (a.type) {
    case types.POINTS_WILL_REFRESH:
      return { ...s, fetching: true, error: null };
    case types.POINTS_DID_REFRESH_FAILED:
      return { ...s, fetching: false, error: a.error };
    case types.POINTS_DID_REFRESH:
      return { ...s, fetching: false, error: null };
    case types.SWTICH_POINTS_SUB_TABS:
      return { ...s, prevTabPath: a.pathname };
    default:
      return s;
  }
};

const data = (s = initialState.data, a) => {
  switch (a.type) {
    case types.POINTS_DID_REFRESH:
      return { ...a.data };
    default:
      return s;
  }
};

export default combineReducers({ ui, data });

const getAvailablePoints = state => state.points.data.available_points;

export { initialState, getAvailablePoints };
